export enum MyCareTeamPathsEnum {
  ROOT = "my-care-team",
}

export enum MyCareTeamRoutesEnum {
  ROOT = "/menu/my-care-team",
}
